import { HiddenField, SelectField, LongTextField } from 'uniforms-bootstrap3';

import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Mongo } from 'meteor/mongo';

import { BaseSchema } from '../baseSchema';
import CustomListField from '../../components/fields/customListField';
import DatePickerField from '../../components/fields/datePickerField';
import DynamicListField from '../../components/fields/dynamicListField';

export const Alerts = new Mongo.Collection('alerts');
export default Alerts;

Alerts.attachRoles('alerts');

Alerts.label = "Alertes";

export const AlertSchema = new SimpleSchema([{
    content: {
        type: String,
        label: "Contenu",
        uniforms: {
            component: LongTextField
        }
    },
    from: {
        type: String,
        label: "Date de début",
        hide: true,
        uniforms: {
            component: DatePickerField
        }
    },
    to: {
        type: String,
        hide: true,
        label: "Date de fin",
        uniforms: {
            component: DatePickerField
        }
    },
    ref: {
    	type: String,
        label: "Référence",
        optional: true,
        hide: true,
        uniforms: {
            component: HiddenField
        }
    },
    to_type: {
        type: [String],
        label: "Visible par",
        hide: true,
        optional: true,
        allowedValues: ["organizer", "pilot", "partner", "god"],
        uniforms: {
            component: CustomListField,
            transform: (option) => {
                switch (option) {
                    case "organizer":
                        return "Administrateur";
                    case "pilot":
                        return "Pilote";
                    case "partner":
                        return "Partenaire";
                    case "god":
                        return "Super-Administrateur";
                    default:
                        return "N/C";
                }
            }
        }
    },
    to_users: {
        type: [String],
        label: "Visble pour les utilisateurs",
        hide: true,
        uniforms: {
            component: DynamicListField,
            options: Meteor.users,
            subscription: "users",
            filters: {},
        }
    },
    type: {
        type: String,
        label: "Type",
        allowedValues: ["Alerte", "Attention", "Information"],
        defaultValue: "Alerte",
        uniforms: {
            component: SelectField
        }
    }
}, BaseSchema]);

Alerts.attachSchema(AlertSchema);



/** WEBPACK FOOTER **
 ** ./src/universal/collections/alerts/alerts.js
 **/